// extracted by mini-css-extract-plugin
export default {"action-items":"WorksheetSettingsPagex_action-items__n2Vh9","placeholder":"WorksheetSettingsPagex_placeholder__UNv5N"};